import styled, { keyframes } from 'styled-components'

const fadeInUP = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`

export const DropDown = styled.div`
  box-sizing: border-box;
  position: absolute;
  top: 100%;
  margin-top: -2px;
  width: 100%;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  background-color: #fff;
  border: 0.125rem solid #24273a;
  z-index: 4;
  animation: ${fadeInUP} 200ms;
  width: 100%;
`

export const DropDownOption = styled.div`
  padding: 12px 16px;
  cursor: pointer;
  outline: none;
  &:hover {
    background-color: #f7f7f7;
  }
  &.active {
    background-color: #f7f7f7;
  }
`

export const ResultContainer = styled.div`
  animation: ${fadeInUP} 500ms;
`
